import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ecmr } from '@app/shared/models/ecmr/Ecmr';
import { EcmrExternalImportLink } from '@app/shared/models/ecmr/EcmrExternalImportLink';
import { EcmrExternalImport } from '@app/shared/models/ecmr/EcmrExternalImport';
import { EcmrUrlResolverService } from './ecmr-url-resolver.service';

@Injectable({
    providedIn: 'root',
})
export class EcmrExternalService {
    constructor(
        private http: HttpClient,
        private ecmrUrlResolver: EcmrUrlResolverService
    ) {}

    importEcmrWithFullLink(fullLink: EcmrExternalImportLink) {
        return this.http.post<Ecmr>(
            `${this.ecmrUrlResolver.getEcmrUrl()}/ecmr/importWithFullLink`,
            fullLink
        );
    }

    importEcmr(importDto: EcmrExternalImport) {
        return this.http.post<Ecmr>(
            `${this.ecmrUrlResolver.getEcmrUrl()}/ecmr/import`,
            importDto
        );
    }
}
